import React from 'react'
import { formatDate, formatCnpj } from '@btime/helpers'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  return reply.value
}

export const formatCNPJ = cnpj => {
  return formatCnpj(cnpj.toString())
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  return formatDate(format, date)
}

export const toCurrency = value => {
  const invalid_values = ['N/A', '', NaN]
  if (invalid_values.includes(Number(value))) {
    return
  }
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })

  return formatter.format(value)
}

export const statePreposition = state => {
  switch (state.replace(/\s/g, '').toLowerCase()) {
    case 'Acre'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Alagoas'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Amapá'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Amazonas'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Bahia'.replace(/\s/g, '').toLowerCase():
      return 'da'
    case 'Ceará'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Espírito Santo'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Goiás'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Maranhão'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Mato Grosso'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Mato Grosso do Sul'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Minas Gerais'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Pará'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Paraíba'.replace(/\s/g, '').toLowerCase():
      return 'da'
    case 'Paraná'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Pernambuco'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Piauí'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Rio de Janeiro'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Rio Grande do Norte'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Rio Grande do Sul'.replace(/\s/g, '').toLowerCase():
      return 'do'
    case 'Rondônia'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Roraima'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Santa Catarina'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'São Paulo'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Sergipe'.replace(/\s/g, '').toLowerCase():
      return 'de'
    case 'Tocantins'.replace(/\s/g, '').toLowerCase():
      return 'de'
    default:
      return 'de'
  }
}

export const getImages = (reply, index = -1) => {
  if (index >= 0) {
    return [reply.value[index].src]
  }
  return reply.value ? reply.value : reply
}

export const getContractorData = reply => {
  if (reply.value.name === 'HRH Fortaleza') {
    return (
      <>
        de um lado, <b>HRH FORTALEZA EMPREENDIMENTO HOTELEIRO S/A</b>, sociedade anônima de capital fechado, inscrita no
        CNPJ/MF sob o nº 24.241.659/0002-89, inscrição municipal nº 502588-5, com sede na Avenida Dom Luís, nº 1.200,
        sala 1905, Bairro Aldeota, na cidade de Fortaleza, Estado do Ceará, CEP 60.160-196, neste ato representada na
        forma do seu estatuto social, doravante designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
  if (reply.value.name === 'HRH São Paulo') {
    return (
      <>
        de um lado, <b>HRH FORTALEZA EMPREENDIMENTO HOTELEIRO S/A</b>, sociedade anônima de capital fechado, inscrita no
        CNPJ/MF sob o nº 24.241.659/0001-06, com sede na Avenida Paulista, nº 777, Conjunto 61, Bairro Bela Vista, na
        cidade de São Paulo, Estado de São Paulo, CEP 01.311-100, neste ato representada na forma do seu estatuto
        social, doravante designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
  if (reply.value.name === 'VENTURE SÃO PAULO') {
    return (
      <>
        de um lado, <b>RESIDENCE CLUB S/A</b>, sociedade anônima de capital fechado, inscrita no CNPJ/MF sob o nº
        24.241.659/0001-06, com sede na Avenida Paulista, nº 777, Conjunto 61, Bairro Bela Vista, na cidade de São
        Paulo, Estado de São Paulo, CEP 01.311-100, neste ato representada na forma do seu estatuto social, doravante
        designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
  if (reply.value.name === 'VENTURE FORTALEZA') {
    return (
      <>
        de um lado, <b>RESIDENCE CLUB S/A</b>, sociedade anônima de capital fechado, inscrita no CNPJ/MF sob o nº
        24.241.659/0002-89, inscrição municipal nº 502588-5, com sede na Avenida Dom Luís, nº 1.200, sala 1905, Bairro
        Aldeota, na cidade de Fortaleza, Estado do Ceará, CEP 60.160-196, neste ato representada na forma do seu
        estatuto social, doravante designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
  if (reply.value.name === 'HRH IDS') {
    return (
      <>
        de um lado, <b>HRH ILHA DO SOL EMPREENDIMENTOS IMOBILIÁRIOS SPE S/A</b>, sociedade anônima de capital fechado,
        inscrita no CNPJ/MF sob o nº 12.827.269/0001-25, com sede na Ilha nº 7 (sete), da Represa Capivara, na cidade de
        Sertaneja, Estado do Paraná, CEP 86.340-000, neste ato representada na forma do seu contrato social, doravante
        designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
  if (reply.value.name === 'HRH JERI') {
    return (
      <>
        de um lado, <b>HRH JERICOACOARA EMPREENDIMENTO HOTELEIRO SPE LTDA</b>, sociedade limitada unipessoal, inscrita
        no CNPJ/MF sob o nº 43.546.450/0001-97, com sede na Avenida da Lagoa, s/n, Bairro Córrego do Urubu II, Sítio
        Paraíso, na cidade de Jijoca de Jericoacoara, Estado do Ceará, CEP 62.598-000, neste ato representada na forma
        do seu contrato social, doravante designada apenas como <b>"CONTRATANTE"</b>;
      </>
    )
  }
}

export const getContractorCNPJ = reply => {
  if (reply.value.name === 'HRH São Paulo') {
    return '24.241.659/0001-06'
  }
  if (reply.value.name === 'HRH Fortaleza') {
    return '24.241.659/0002-89'
  }
  if (reply.value.name === 'VENTURE SÃO PAULO') {
    return '24.241.659/0001-06'
  }
  if (reply.value.name === 'VENTURE FORTALEZA') {
    return '24.241.659/0002-89'
  }
  if (reply.value.name === 'HRH IDS') {
    return '12.827.269/0001-25'
  }
  if (reply.value.name === 'HRH JERI') {
    return '43.546.450/0001-97'
  }
}

export const getContractorCityAndState = reply => {
  if (reply.value.name === 'HRH São Paulo') {
    return 'São Paulo (SP)'
  }
  if (reply.value.name === 'HRH Fortaleza') {
    return 'Fortaleza (CE)'
  }
  if (reply.value.name === 'VENTURE SÃO PAULO') {
    return 'São Paulo (SP)'
  }
  if (reply.value.name === 'VENTURE FORTALEZA') {
    return 'Fortaleza (CE)'
  }
  if (reply.value.name === 'HRH IDS') {
    return 'Sertaneja (PR)'
  }
  if (reply.value.name === 'HRH JERI') {
    return 'Jericoacoara (CE)'
  }
}

export const signatureText = reply => {
  if (reply.value.name === 'HRH São Paulo') {
    return 'HRH FORTALEZA EMPREENDIMENTO HOTELEIRO S/A'
  }
  if (reply.value.name === 'HRH Fortaleza') {
    return 'HRH FORTALEZA EMPREENDIMENTO HOTELEIRO S/A'
  }
  if (reply.value.name === 'VENTURE SÃO PAULO') {
    return 'RESIDENCE CLUB S/A'
  }
  if (reply.value.name === 'VENTURE FORTALEZA') {
    return 'RESIDENCE CLUB S/A'
  }
  if (reply.value.name === 'HRH IDS') {
    return 'HRH ILHA DO SOL EMPREENDIMENTOS IMOBILIÁRIOS SPE S/A'
  }
  if (reply.value.name === 'HRH JERI') {
    return 'HRH JERICOACOARA EMPREENDIMENTO HOTELEIRO SPE LTDA'
  }
}

export const getServiceDetailsByTemplateId = templateId => {
  if ([2, 11].includes(templateId)) {
    return {
      service: 'Promoção de vendas e captação',
      clause01Description: 'promoção de vendas',
      clause03Description: 'na captação de clientes em potencial'
    }
  }
  if ([3, 12].includes(templateId)) {
    return {
      service: 'Treinamento e acompanhamento da promoção de vendas e captação de clientes',
      clause01Description: 'promoção de vendas',
      clause03Description: 'no treinamento e acompanhamento da promoção de vendas e captação de clientes em potencial'
    }
  }
  if ([4, 13].includes(templateId)) {
    return {
      service: 'Orientação da promoção de vendas',
      clause01Description: 'promoção de vendas',
      clause03Description: 'na orientação da promoção de vendas e captação de clientes em potencial'
    }
  }
  if ([5, 14].includes(templateId)) {
    return {
      service: 'Consultoria e promoção de vendas',
      clause01Description: 'consultoria e promoção de vendas',
      clause03Description:
        'na apresentação do produto (liner) e/ou apresentação dos valores (closer) ao cliente em potencial'
    }
  }
  if ([6, 15].includes(templateId)) {
    return {
      service: 'Treinamento e acompanhamento do consultor de vendas',
      clause01Description: 'consultoria e promoção de vendas',
      clause03Description:
        'no treinamento e acompanhamento da apresentação do produto (liner) e dos valores (closer) ao cliente em potencial'
    }
  }
  if ([7].includes(templateId)) {
    return {
      service: 'Assessoria comercial',
      clause01Description: 'serviços especializados de assessoria comercial',
      clause03Description: 'na captação de clientes em potencial'
    }
  }
  return {
    service: 'Assessoria comercial',
    clause01Description: 'promoção de vendas',
    clause03Description: 'na captação de clientes em potencial'
  }
}
